import type { Category } from "@/types/video";

export const categories: Category[] = [
  {
    id: "star-latest",
    name: "明星动态",
    description:
      "追踪一线明星的最新行程、官宣、片场花絮与私下日常，第一时间用视频还原台前幕后，让你不错过任何一条明星动向。",
    icon: "ri-star-smile-line",
  },
  {
    id: "net-buzz",
    name: "网络热议",
    description:
      "汇总全网正在刷屏的热门事件与讨论焦点，用精简视频梳理来龙去脉，带你看懂评论区吵翻天的前因后果。",
    icon: "ri-fire-line",
  },
  {
    id: "hot-review",
    name: "热门视频",
    description:
      "精选播放量暴涨的热门视频解析，从镜头语言到细节彩蛋逐帧拆解，帮你在几分钟内抓住爆款内容的真正看点。",
    icon: "ri-play-circle-line",
  },
  {
    id: "deep-insight",
    name: "深度解析",
    description:
      "不止于八卦表面，深度解读事件背后的资本、人脉与商业逻辑，长视频深度访谈与资料考证，给你更有分量的信息。",
    icon: "ri-movie-2-line",
  },
];

export default categories;